import { render, staticRenderFns } from "./PostingModule.vue?vue&type=template&id=0c30d52e&scoped=true"
import script from "./PostingModule.vue?vue&type=script&lang=js"
export * from "./PostingModule.vue?vue&type=script&lang=js"
import style0 from "./PostingModule.vue?vue&type=style&index=0&id=0c30d52e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c30d52e",
  null
  
)

export default component.exports